import {DestroyRef, inject, Pipe, PipeTransform} from '@angular/core';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {distinctUntilChanged, shareReplay} from "rxjs/operators";
import {Observable, take} from "rxjs";
import {IProjectCurrency} from "@shared/model/project";
import {Store} from "@ngrx/store";
import {IRootState} from "@app/store";
import {selectCurrency} from "@app/project/store";

@Pipe({
  name: 'projectCurrency',
  standalone: true
})
export class ProjectCurrencyPipe implements PipeTransform {
  private projectCurrency$: Observable<IProjectCurrency> = this._store.select(selectCurrency);
  private destroyRef = inject(DestroyRef);

  constructor(private _store: Store<IRootState>) {
  }

  transform(
    value: string,
    mode: 'full' | 'currency' | 'multiplication' = 'full',
    addText: string = ''
  ): Observable<string> {
    return new Observable<string>(observer => {
      this.projectCurrency$
        .pipe(
          distinctUntilChanged(),
          shareReplay(),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(currencyData => {
          let result = value;
          let hasCurrencyData = false;
          let parts: string[] = [];

          switch (mode) {
            case 'full':
              if (currencyData?.currency) parts.push(currencyData.currency);
              if (currencyData?.currency_multiplication) parts.push(currencyData.currency_multiplication);
              hasCurrencyData = parts.length > 0;
              if (hasCurrencyData) {
                result = `${value}, ${parts.join(' ')}${addText}`;
              }
              break;

            case 'currency':
              if (currencyData?.currency) {
                result = `${value}, ${currencyData.currency}${addText}`;
              }
              break;

            case 'multiplication':
              if (currencyData?.currency_multiplication) {
                result = `${value}, ${currencyData.currency_multiplication}${addText}`;
              }
              break;
          }

          observer.next(result);
        });
    });
  }
}
